import React, { useState, useEffect, useRef, useMemo} from 'react';
import { Typography, Button, IconButton, Grid, Box, Drawer} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider } from "@material-ui/core/styles";

import ClearIcon from '@material-ui/icons/Clear';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';

import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';

import axios from "axios";
import classNames from 'classnames';

import { customTheme } from '../../../StyleComponents/Styledatatable';
import useStyles from '../../../StyleComponents/StyleFunctionComponent';

import { API_BASE_URL, token, userLevel, adminId} from '../../../../constants';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import VisibilityIcon from '@material-ui/icons/Visibility';

import GetAppIcon from "@material-ui/icons/GetApp";
import PrintIcon from "@material-ui/icons/Print";
const FinanceResponse = () => {
    const classes = useStyles();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [viewOpen, setViewOpen] = useState(false);
    const [viewData, setViewData] = useState(null);
    const currentDate = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(
        currentDate.getDate() - 7
    );
    const [fromDate, setFromDate] = useState(
        sevenDaysAgo.toISOString().split('T')[0]
    );
    const [toDate, setToDate] = useState(
        currentDate.toISOString().split('T')[0]
    );
    const [clientName, setClientName] = useState('');
    const [status, setStatus] = useState('');
    const [appliedFilters, setAppliedFilters] = useState(null);
    const sourceRef = useRef(null);
    const fetchData = async (
        customPage = page,
        customPerPage = perPage,
        customFromDate = fromDate,
        customToDate = toDate,
        customClientName = clientName,
        customStatus = status
    ) => {
        if (sourceRef.current) {
            sourceRef.current.cancel(
                'Previous request cancelled.'
            );
        }
        sourceRef.current =
            axios.CancelToken.source();
        setIsLoading(true);
        setError(null);
        try {
            const config = {
                headers: {
                    'Content-Type':
                        'application/json',
                    'Accept':
                        'application/json',
                    'Authorization':
                        `${token}`,
                    'adminId':
                        `${adminId}`,
                    'userLevel':
                        `${userLevel}`,
                },
                cancelToken:
                    sourceRef.current.token,
                timeout:
                    Infinity,
            };
            const requestData = {
                start_date:
                    customFromDate,
                end_date:
                    customToDate,
                pagination:
                    customPerPage,
                page:
                    customPage + 1,
            };
            if (
                customClientName &&
                customClientName.trim() !== ''
            ) {
                requestData.client_name =
                    customClientName.trim();
            }
            if (customStatus && customStatus.trim() !== '') {
                requestData.status = customStatus.trim();
            }
            console.log(
                "Finance Loan Request:",
                requestData
            );
            const response =
                await axios.post(
                    `${API_BASE_URL}/api/admin/v2/finance-loan-enquiry-responses`,
                    requestData,
                    config
                );
            const paginationData =
                response?.data?.data || {};
            const responseList =
                Array.isArray(
                    paginationData.finance_loan_enquiries
                )
                    ? paginationData.finance_loan_enquiries
                    : [];
            const mappedData =
                responseList.map(
                    (item) => {
                        let requestJson =
                            item.request || "";
                        let responseJson =
                            item.response || "";
                        if (requestJson) {
                            try {
                                if (
                                    typeof requestJson ===
                                    "string"
                                ) {
                                    requestJson =
                                        JSON.stringify(
                                            JSON.parse(
                                                requestJson
                                            ),
                                            null,
                                            2
                                        );
                                } else {
                                    requestJson =
                                        JSON.stringify(
                                            requestJson,
                                            null,
                                            2
                                        );
                                }
                            } catch (e) {
                                requestJson =
                                    item.request || "";
                            }
                        }
                        if (responseJson) {
                            try {
                                if (
                                    typeof responseJson ===
                                    "string"
                                ) {
                                    responseJson =
                                        JSON.stringify(
                                            JSON.parse(
                                                responseJson
                                            ),
                                            null,
                                            2
                                        );
                                } else {
                                    responseJson =
                                        JSON.stringify(
                                            responseJson,
                                            null,
                                            2
                                        );
                                }
                            } catch (e) {
                                responseJson =
                                    item.response || "";
                            }
                        }
                        return {
                            id:
                                item.id || "",
                            enquiry_id:
                                item.enquiry_id || "",
                            client_name:
                                item.client_name || "",
                            product_code:
                                item.product_code || "",
                            status:
                                item.status || "",
                            user:
                                item.user || "",
                            mobile:
                                item.mobile || "",
                            email:
                                item.email || "",
                            state:
                                item.state || "",
                            city:
                                item.city || "",
                            taluka:
                                item.taluka || "",
                            created_at:
                                item.created_at || "",
                            updated_at:
                                item.updated_at || "",
                            request:
                                requestJson,
                            response:
                                responseJson,
                        };
                    }
                );
            setData(
                mappedData
            );
            setTotalCount(
                Number(
                    paginationData.total || 0
                )
            );
        } catch (error) {
            if (
                axios.isCancel(error)
            ) {
                console.log(
                    "Request cancelled:",
                    error.message
                );
                return;
            }
            console.error(
                "Finance Loan API Error:",
                error
            );
            if (
                error.response
            ) {
                console.error(
                    "Backend Error:",
                    error.response.data
                );
                let message =
                    error.response?.data?.message;
                if (
                    Array.isArray(message)
                ) {
                    message =
                        message.join(", ");
                }
                setError(
                    message ||
                    `Error ${error.response.status}`
                );
            } else if (
                error.request
            ) {
                setError(
                    "Server did not respond."
                );
            } else {
                setError(
                    error.message ||
                    "Unable to fetch finance loan enquiry responses."
                );
            }
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (appliedFilters) {
            fetchData(
                page,
                perPage,
                appliedFilters.fromDate,
                appliedFilters.toDate,
                appliedFilters.clientName,
                appliedFilters.status
            );
        } else {
            fetchData(page, perPage);
        }
        return () => {
            if (sourceRef.current) {
                sourceRef.current.cancel('Component unmounted.');
            }
        };
    }, [page, perPage, appliedFilters]);
    const handleDateChange = (e) => {
        const {
            name,
            value
        } = e.target;
        if (
            name === "fromDate"
        ) {
            setFromDate(value);
        }
        if (
            name === "toDate"
        ) {
            setToDate(value);
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setOpenSidebar(false);
        setPage(0);
        setAppliedFilters({ fromDate, toDate, clientName, status });
    };
    const clearForm = () => {
        const today = new Date();
        const previousDate = new Date();
        previousDate.setDate(today.getDate() - 7);
        const defaultFrom = previousDate.toISOString().split('T')[0];
        const defaultTo = today.toISOString().split('T')[0];
        setFromDate(defaultFrom);
        setToDate(defaultTo);
        setClientName('');
        setStatus('');
        setOpenSidebar(false);
        setPage(0);
        setAppliedFilters({
            fromDate: defaultFrom,
            toDate: defaultTo,
            clientName: '',
            status: ''
        });
    };
    const handleView = (row) => {
        setViewData(row);
        setViewOpen(true);
    };
    const handleCloseView = () => {
        setViewOpen(false);
        setViewData(null);
    };
    const columns = [
        {
            name:
                "id",
            label:
                "ID",
            options: {
                filter:
                    false,
                sort:
                    true,
            }
        },
        {
            name:
                "enquiry_id",
            label:
                "Enquiry ID",
            options: {
                filter:
                    false,
                sort:
                    true,
            }
        },
        {
            name:
                "client_name",
            label:
                "Client Name",
            options: {
                filter:
                    true,
                sort:
                    true,
            }
        },
        {
            name:
                "product_code",
            label:
                "Product",
            options: {
                filter:
                    true,
                sort:
                    true,
            }
        },
        {
            name:
                "status",
            label:
                "Status",
            options: {
                filter:
                    true,
                sort:
                    true,
                customBodyRender:
                    (
                        value
                    ) => {
                        const status =
                            value
                                ? String(value)
                                    .toLowerCase()
                                : "";
                        const isSuccess =
                            status ===
                            "success";
                        return (
                            <span
                                style={{
                                    display:
                                        "inline-block",
                                    padding:
                                        "4px 10px",
                                    borderRadius:
                                        "15px",
                                    fontSize:
                                        "12px",
                                    fontWeight:
                                        600,
                                    backgroundColor:
                                        isSuccess
                                            ? "#d4edda"
                                            : "#f8d7da",
                                    color:
                                        isSuccess
                                            ? "#155724"
                                            : "#721c24",
                                }}
                            >
                                {
                                    value ||
                                    "-"
                                }
                            </span>
                        );
                    }
            }
        },
        {
            name:
                "user",
            label:
                "Customer Name",
            options: {
                filter:
                    true,
                sort:
                    true,
            }
        },
        {
            name:
                "mobile",
            label:
                "Mobile",
            options: {
                filter:
                    false,
                sort:
                    false,
            }
        },
        {
            name:
                "email",
            label:
                "Email",
            options: {
                filter:
                    false,
                sort:
                    false,
                customBodyRender:
                    (
                        value
                    ) => (
                        value || "-"
                    )
            }
        },
        {
            name:
                "state",
            label:
                "State",
            options: {
                filter:
                    true,
                sort:
                    true,
            }
        },
        {
            name:
                "city",
            label:
                "City",
            options: {
                filter:
                    true,
                sort:
                    true,
            }
        },
        {
            name:
                "taluka",
            label:
                "Taluka",
            options: {
                filter:
                    true,
                sort:
                    true,
            }
        },
        {
            name:
                "created_at",
            label:
                "Created At",
            options: {
                filter:
                    false,
                sort:
                    false,
            }
        },
        {
            name:
                "updated_at",
            label:
                "Updated At",
            options: {
                filter:
                    false,
                sort:
                    false,
            }
        },
        {
            name:
                "request",
            label:
                "Request",
            options: {
                filter:
                    false,
                sort:
                    false,
                customBodyRender:
                    (
                        value
                    ) => (
                        <div
                            style={{
                                minWidth:
                                    "300px",
                                maxWidth:
                                    "400px",
                                maxHeight:
                                    "180px",
                                overflow:
                                    "auto",
                                whiteSpace:
                                    "pre-wrap",
                                wordBreak:
                                    "break-word",
                                fontSize:
                                    "11px",
                                fontFamily:
                                    "monospace",
                                background:
                                    "#f8f9fa",
                                padding:
                                    "8px",
                                border:
                                    "1px solid #eee",
                                borderRadius:
                                    "4px",
                            }}
                        >
                            {
                                value ||
                                "-"
                            }
                        </div>
                    )
            }
        },
        {
            name:
                "response",
            label:
                "Response",
            options: {
                filter:
                    false,
                sort:
                    false,
                customBodyRender:
                    (
                        value
                    ) => (
                        <div
                            style={{
                                minWidth:
                                    "300px",
                                maxWidth:
                                    "400px",
                                maxHeight:
                                    "180px",
                                overflow:
                                    "auto",
                                whiteSpace:
                                    "pre-wrap",
                                wordBreak:
                                    "break-word",
                                fontSize:
                                    "11px",
                                fontFamily:
                                    "monospace",
                                background:
                                    "#f8f9fa",
                                padding:
                                    "8px",
                                border:
                                    "1px solid #eee",
                                borderRadius:
                                    "4px",
                            }}
                        >
                            {
                                value ||
                                "-"
                            }
                        </div>
                    )
            }
        },
        {
            name:
                "view",
            label:
                "View",
            options: {
                filter:
                    false,
                sort:
                    false,
                customBodyRenderLite:
                    (
                        dataIndex
                    ) => {
                        const row =
                            data[dataIndex];
                        return (
                            <IconButton
                                size="small"
                                onClick={() =>
                                    handleView(
                                        row
                                    )
                                }
                                style={{
                                    color:
                                        "#1976d2"
                                }}
                            >
                                <VisibilityIcon />
                            </IconButton>
                        );
                    }
            }
        }
    ];
    const toggleSidebar = () => {
        setOpenSidebar(
            prev => !prev
        );
    };
    const exportColumns = [
        ["id", "ID"], ["enquiry_id", "Enquiry ID"],
        ["client_name", "Client Name"], ["product_code", "Product Code"],
        ["status", "Status"], ["user", "Customer Name"],
        ["mobile", "Mobile"], ["email", "Email"],
        ["state", "State"], ["city", "City"],
        ["taluka", "Taluka"], ["created_at", "Created At"],
        ["updated_at", "Updated At"], ["request", "Request"],
        ["response", "Response"]
    ];
    const toExportText = (value) => {
        if (value === null || value === undefined) return "";
        return typeof value === "object" ? JSON.stringify(value) : String(value);
    };
    const csvCell = (value) => {
        let text = toExportText(value);
        if (/^[=+@\-\t\r]/.test(text)) text = "'" + text;
        return '"' + text.replace(/"/g, '""') + '"';
    };
    const handleDownloadCSV = () => {
        if (!data.length) return;
        const rows = [
            exportColumns.map(([, label]) => csvCell(label)).join(","),
            ...data.map((item) => exportColumns.map(([key]) => csvCell(item[key])).join(","))
        ];
        const blob = new Blob(["\uFEFF" + rows.join("\r\n")], {type: "text/csv;charset=utf-8;"});
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `FinanceResponse_${fromDate}_${toDate}_page${page + 1}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    const escapeHTML = (value) => toExportText(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    const handlePrint = () => {
        if (!data.length) return;
        const popup = window.open("", "_blank");
        if (!popup) return;
        const headings = exportColumns.map(([, label]) => `<th>${escapeHTML(label)}</th>`).join("");
        const rows = data.map((item) => `<tr>${exportColumns.map(([key]) => `<td>${escapeHTML(item[key])}</td>`).join("")}</tr>`).join("");
        popup.document.open();
        popup.document.write(`<!doctype html><html><head><title>Finance Response Report</title><style>
            @page{size:landscape;margin:10mm}body{font-family:Arial,sans-serif;font-size:10px}
            h2{margin:0 0 10px}table{width:100%;border-collapse:collapse}
            th,td{border:1px solid #aaa;padding:5px;vertical-align:top;overflow-wrap:anywhere}
            th{background:#eee}thead{display:table-header-group}
            </style></head><body><h2>Finance Response Report</h2>
            <p>${escapeHTML(fromDate)} to ${escapeHTML(toDate)} | Page ${page + 1}</p>
            <table><thead><tr>${headings}</tr></thead><tbody>${rows}</tbody></table></body></html>`);
        popup.document.close();
        popup.focus();
        popup.setTimeout(() => popup.print(), 350);
    };
    const CustomToolbarAction = () => (
        <>
            <IconButton aria-label="Download CSV" title="Download CSV" onClick={handleDownloadCSV} disabled={!data.length}>
                <GetAppIcon />
            </IconButton>
            <IconButton aria-label="Print" title="Print" onClick={handlePrint} disabled={!data.length}>
                <PrintIcon />
            </IconButton>
            <IconButton aria-label="Filter list" title="Filter" onClick={toggleSidebar}>
                <FilterListIcon />
            </IconButton>
        </>
    );
    useEffect(() => {
        const handleKeyPress =
            (event) => {
                if (
                    event.shiftKey &&
                    (
                        event.key === 'F' ||
                        event.key === 'f'
                    )
                ) {
                    setOpenSidebar(true);
                }
            };
        window.addEventListener(
            "keydown",
            handleKeyPress
        );
        return () => {
            window.removeEventListener(
                "keydown",
                handleKeyPress
            );
        };
    }, []);
    const options = {
        rowsPerPage:
            perPage,
        page:
            page,
        count:
            totalCount,
        serverSide:
            true,
        selectableRows:
            "none",
        filter:
            false,
        search:
            false,
        print:
            false,
        download:
            false,
        viewColumns:
            true,
        responsive:
            "standard",
        fixedHeader:
            true,
        rowsPerPageOptions: [
            10,
            25,
            50,
            100,
            500,
            1000
        ],
        onTableChange:
            (
                action,
                tableState
            ) => {
                if (
                    action ===
                    "changePage"
                ) {
                    setPage(
                        tableState.page
                    );
                }
                if (
                    action ===
                    "changeRowsPerPage"
                ) {
                    setPerPage(
                        tableState.rowsPerPage
                    );
                    setPage(0);
                }
            },
        customToolbar:
            () => (
                <CustomToolbarAction />
            ),
    };
    const currentTheme =
        customTheme(true);
    const memoizedData =
        useMemo(
            () => data,
            [data]
        );
    return (
        <>
            <Box
                sx={{
                    width:
                        "100%"
                }}
            >
                <Grid
                    container
                >
                    <Grid
                        item
                        xs={6}
                        style={{
                            marginTop:
                                "8px"
                        }}
                    >
                        <Typography
                            className={
                                classNames(
                                    classes.pagetittle,
                                    classes.pagetittlestyle
                                )
                            }
                        >
                            Finance Loan Enquiry Responses
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={6}
                    />
                </Grid>
                <hr
                    className={
                        classes.horizontalline
                    }
                />
            </Box>
            {
                error && (
                    <div
                        style={{
                            padding:
                                "10px",
                            color:
                                "#721c24",
                            backgroundColor:
                                "#f8d7da",
                            border:
                                "1px solid #f5c6cb",
                            borderRadius:
                                "4px",
                            marginBottom:
                                "10px"
                        }}
                    >
                        {
                            error
                        }
                    </div>
                )
            }
            <MuiThemeProvider
                theme={
                    currentTheme
                }
            >
                {
                    isLoading && (
                        <LinearProgress />
                    )
                }
                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton
                                animation="wave"
                            />
                        ) : (
                            <Typography
                                className={
                                    classes.tabletittle
                                }
                            >
                                Finance Loan Enquiry Responses
                            </Typography>
                        )
                    }
                    data={
                        memoizedData
                    }
                    columns={
                        columns
                    }
                    options={
                        options
                    }
                />
            </MuiThemeProvider>
            <Dialog
                open={
                    viewOpen
                }
                onClose={
                    handleCloseView
                }
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    Finance Enquiry Details
                </DialogTitle>
                <DialogContent
                    dividers
                >
                    {
                        viewData && (
                            <Grid
                                container
                                spacing={2}
                            >
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <b>ID:</b>{" "}
                                    {
                                        viewData.id ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <b>Enquiry ID:</b>{" "}
                                    {
                                        viewData.enquiry_id ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <b>Client Name:</b>{" "}
                                    {
                                        viewData.client_name ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <b>Product:</b>{" "}
                                    {
                                        viewData.product_code ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <b>Status:</b>{" "}
                                    {
                                        viewData.status ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <b>Customer Name:</b>{" "}
                                    {
                                        viewData.user ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <b>Mobile:</b>{" "}
                                    {
                                        viewData.mobile ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <b>Email:</b>{" "}
                                    {
                                        viewData.email ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                >
                                    <b>State:</b>{" "}
                                    {
                                        viewData.state ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                >
                                    <b>City:</b>{" "}
                                    {
                                        viewData.city ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                >
                                    <b>Taluka:</b>{" "}
                                    {
                                        viewData.taluka ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <b>Created At:</b>{" "}
                                    {
                                        viewData.created_at ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <b>Updated At:</b>{" "}
                                    {
                                        viewData.updated_at ||
                                        "-"
                                    }
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                >
                                    <b>Request:</b>
                                    <pre
                                        style={{
                                            whiteSpace:
                                                "pre-wrap",
                                            wordBreak:
                                                "break-word",
                                            background:
                                                "#f5f5f5",
                                            padding:
                                                "10px",
                                            marginTop:
                                                "5px",
                                            maxHeight:
                                                "250px",
                                            overflow:
                                                "auto"
                                        }}
                                    >
                                        {
                                            viewData.request ||
                                            "-"
                                        }
                                    </pre>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                >
                                    <b>Response:</b>
                                    <pre
                                        style={{
                                            whiteSpace:
                                                "pre-wrap",
                                            wordBreak:
                                                "break-word",
                                            background:
                                                "#f5f5f5",
                                            padding:
                                                "10px",
                                            marginTop:
                                                "5px",
                                            maxHeight:
                                                "250px",
                                            overflow:
                                                "auto"
                                        }}
                                    >
                                        {
                                            viewData.response ||
                                            "-"
                                        }
                                    </pre>
                                </Grid>
                            </Grid>
                        )
                    }
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={
                            handleCloseView
                        }
                        color="primary"
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Drawer
                anchor="right"
                open={
                    openSidebar
                }
                onClose={() =>
                    setOpenSidebar(false)
                }
                PaperProps={{
                    style: {
                        width:
                            "100%",
                        maxWidth:
                            320,
                        padding:
                            "10px",
                    }
                }}
            >
                <form
                    onSubmit={
                        handleSubmit
                    }
                >
                    <Grid
                        container
                        spacing={1}
                    >
                        <Grid
                            item
                            xs={12}
                            style={{
                                textAlign:
                                    "right"
                            }}
                        >
                            <ClearIcon
                                style={{
                                    color:
                                        "#c0392b",
                                    cursor:
                                        "pointer"
                                }}
                                onClick={() =>
                                    setOpenSidebar(
                                        false
                                    )
                                }
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                        >
                            <Typography
                                className={
                                    classes.tabletittle
                                }
                            >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <br />
                    <div
                        className={
                            classes.root
                        }
                        style={{
                            padding:
                                "0 22px"
                        }}
                    >
                        <Grid
                            container
                            spacing={2}
                        >
                            <Grid
                                item
                                xs={12}
                            >
                                <Typography
                                    variant="caption"
                                >
                                    Start Date
                                </Typography>
                                <input
                                    className={
                                        classes.inputform
                                    }
                                    type="date"
                                    name="fromDate"
                                    value={
                                        fromDate
                                    }
                                    onChange={
                                        handleDateChange
                                    }
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                            >
                                <Typography
                                    variant="caption"
                                >
                                    End Date
                                </Typography>
                                <input
                                    className={
                                        classes.inputform
                                    }
                                    type="date"
                                    name="toDate"
                                    value={
                                        toDate
                                    }
                                    onChange={
                                        handleDateChange
                                    }
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                            >
                                <Typography
                                    variant="caption"
                                >
                                    Client Name
                                </Typography>
                                <select
                                    className={
                                        classes.inputform
                                    }
                                    name="clientName"
                                    value={
                                        clientName
                                    }
                                    onChange={
                                        (e) =>
                                            setClientName(
                                                e.target.value
                                            )
                                    }
                                    style={{
                                        width:
                                            "100%",
                                        height:
                                            "40px"
                                    }}
                                >
                                    <option
                                        value=""
                                    >
                                        Select Client
                                    </option>
                                    <option
                                        value="Tyger"
                                    >
                                        Tyger
                                    </option>
                                </select>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="caption">
                                    Status
                                </Typography>
                                <select
                                    className={classes.inputform}
                                    name="status"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                    style={{ width: "100%", height: "40px" }}
                                >
                                    <option value="">All Status</option>
                                    <option value="success">Success</option>
                                    <option value="fail">Fail</option>
                                </select>
                            </Grid>
                        </Grid>
                    </div>
                    <br />
                    <Grid
                        container
                    >
                        <Grid
                            item
                            xs={12}
                            style={{
                                textAlign:
                                    "center"
                            }}
                        >
                            <Button
                                type="submit"
                                className={
                                    classes.buttonform
                                }
                                variant="outlined"
                                startIcon={
                                    <ApprovalIcon />
                                }
                                style={{
                                    marginRight:
                                        "10px"
                                }}
                            >
                                Apply
                            </Button>
                            <Button
                                type="button"
                                className={
                                    classes.buttonform
                                }
                                variant="outlined"
                                startIcon={
                                    <ClearIcon />
                                }
                                onClick={
                                    clearForm
                                }
                                style={{
                                    backgroundColor:
                                        "#dc3545",
                                    borderColor:
                                        "#dc3545"
                                }}
                            >
                                Clear
                            </Button>
                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer>
        </>
    );
};
export default FinanceResponse;
